import { createMemo, For, Show } from "solid-js";
import { useHeroForm } from "../contexts/HeroFormContext";
import { MobileCustomizationFields } from "./ProductHeroFormFields";
import { getCustomChargeItems } from "../js/itemPropsHelper";
import { NeumorphicCustomizationButton } from "../components/NeumorphicOptionButton";

const CustomizationContainer = (props) => {
  const selectedOption = () =>
    props.customization.options[props.customization.selected];

  console.log("customizatioon: ", props.customization);

  return (
    <div class="px-2 pt-2">
      <div>
        <span class="font-bold">{props.customization.label}: </span>
        <span className="text-xs font-regular">{` ${selectedOption().displayName || selectedOption().label}`}</span>
      </div>
      <Show when={Object.values(props.customization.options).length > 1}>
        <div class="flex gap-1 mt-2 flex-wrap">
          <For each={Object.values(props.customization.options)}>
            {(option) => (
              <NeumorphicCustomizationButton
                id={option.id}
                onClick={() => props.selectionHandler(option.id)}
                selected={props.customization.selected === option.id}
                label={option.displayName || option.label}
              />
            )}
          </For>
        </div>
      </Show>
    </div>
  )
}

export const CustomizationMainForm = (props) => {
  const {
    sizeSettings: {
      sizeData,
      diyData,
      measurementsInfo,
      measurementOptions,
    },
    styleCustomizations: {
      styleCustomizations,
      handlers: { handleStyleSelection },
    },
    fit: {
      fit,
    },
    handlers: { handleCustomizationChange },
    getters: {
      getExperimentFlags
    }
  } = useHeroForm();

  const handleStyleSelectionProxy = (id, selectedOption) => {
    console.log("selectedOption: ", selectedOption);

    handleStyleSelection(id, selectedOption);
    handleCustomizationChange(diyData(), measurementsInfo, {
      sizeCustomization: sizeData()["selected"],
      fitCustomization: fit()["selected"],
      styleCustomizations: styleCustomizations(),
      measurementOption: measurementOptions()["selected"],
    });
  };

  const customizationsArr = () => {
    return Object.values(styleCustomizations())
      .filter((customization) => customization.showInMainForm)
      .filter(
        (customization) =>
          Object.values(customization.options).some((option) => option.isEnabled)
      )
      .map((customization) => {
        const id = customization.id || handleize(customization.label);

        return {
          customization,
          selectionHandler: (selectedOption) => handleStyleSelectionProxy(id, selectedOption),
          type: 'STYLE'
        };
      });
  };

  return (
    <Show when={customizationsArr()?.length > 0}>
      <div class="max-w-lg pb-2 border-frame divide-y divide-frame flex flex-col gap-3 mx-2 sm:mx-6 border boxy-shadow-sm bg-canvas-light">
        <For each={Object.values(customizationsArr())}>
          {(props) => {
            return (
              <>
                <CustomizationContainer
                  customization={props.customization}
                  selectionHandler={props.selectionHandler}
                />
              </>
            );
          }}
        </For>
      </div>
    </Show>
  )
}